import Axios from "../../api/Axios";
const BASE_URL = "SalesOrder/BulkInvGeneration/";

export const EndpointBulkInvGen = {
    GetCustforBulkInv: "GetCustforBulkInv",
    PopulateSalesOrdersGrid: "PopulateSalesOrdersGrid",
    Save: "Save",
};

export const createAPIEndpointBulkInvGen = () => {
    return { 
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data),
    };

};
